import { FC } from 'react';
import {
  MyEquipmentDrawer,
  MyEquipmentDrawerLinkImage,
  MyEquipmentHeader,
  MyEquipmentLinkContent,
  MyEquipmentButton,
  useBreakpoint,
  useDrawer
} from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useTranslations } from 'next-intl';
import { MODEL_LOCATION } from '../../../constants';
import cx from 'classnames';
import styles from '../style.module.scss';

export interface ModelNumberHelpDrawerProps {
  showBackButton: boolean;
  isChild: boolean;
}

export const ModelNumberHelpDrawer: FC<ModelNumberHelpDrawerProps> = ({
  showBackButton,
  isChild
}) => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const drawerModelLink = useDrawer({
    id: 'blocks-my-equipment-drawer-model-link'
  });

  const onCloseFindModel = (e) => {
    e.stopPropagation();
    drawerModelLink.drawerProps.onBlDrawerClose(e);
  };

  const onBackButtonClickOnModel = () => {
    drawerModelLink.closeDrawer();
  };

  const onDrawerModelLinkClick = (e) => {
    e.stopPropagation();
    drawerModelLink.initiatorProps.onClick();
  };

  return (
    <div>
      <MyEquipmentButton
        onClick={(e) => onDrawerModelLinkClick(e)}
        aria-label={t('FIND_MODEL_GUIDE_TEXT')}
        variant={'ghost'}
        className={`${styles['find-equipment-guide-text']} p-0 mt-2 mb-3`}
      >
        <span className={`${styles['button-link--padding']}`}>
          {t('FIND_MODEL_GUIDE_TEXT')}
        </span>
      </MyEquipmentButton>
      <MyEquipmentDrawer
        drawer={drawerModelLink}
        onCloseHandler={onCloseFindModel}
        size="lg"
        isChild={isChild}
      >
        <MyEquipmentHeader
          className="d-flex"
          variant={'title-sm'}
          onBackButtonClick={showBackButton && onBackButtonClickOnModel}
        >
          {t('FIND_MODEL_GUIDE_TEXT')}
        </MyEquipmentHeader>
        <MyEquipmentLinkContent classname={styles['grid']}>
          <MyEquipmentHeader variant={isMD ? 'title' : 'headline'}>
            {t('ADD_EQUIP_FIND_MODEL')}
          </MyEquipmentHeader>
          <MyEquipmentDrawerLinkImage
            src={MODEL_LOCATION.src}
            alt={MODEL_LOCATION.alt}
            classname={cx(styles['image'], 'mt-md-n4 mt-1 pt-3 pt-md-0')}
          />
          <MyEquipmentHeader className="pt-3 mt-1 mt-md-0" variant="body-sm">
            {t('MY_EQUIP_FIND_SERIAL_TEXT1')}
          </MyEquipmentHeader>
        </MyEquipmentLinkContent>
      </MyEquipmentDrawer>
    </div>
  );
};
